import { defineComponent as R, ref as u, computed as H, watch as w, resolveComponent as K, createElementBlock as C, openBlock as p, withModifiers as v, normalizeClass as X, createCommentVNode as f, createElementVNode as m, createVNode as S, toDisplayString as Y } from "vue";
import { v as L } from "./vsIcon-Cyr63bPF.mjs";
import { v as z } from "./vsButton-BlFL21k0.mjs";
import { _ as J } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const D = R({
  name: "vs-upload",
  components: {
    vsIcon: L,
    vsButton: z
  },
  props: {
    color: {
      type: String,
      default: "white"
    },
    size: {
      type: Number,
      default: 10
    },
    isImageUpload: {
      type: Boolean,
      default: !1
    },
    accept: {
      type: String,
      default: "image/*"
    },
    currentFile: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["upload:file", "upload:delete"],
  setup(e, { emit: l }) {
    var G, N;
    const g = u(!1), I = u(null), b = H(() => g.value ? "bg-primary-500 text-on-primary" : ""), B = H(() => g.value ? "on-primary" : "primary"), n = u((G = e.currentFile) == null ? void 0 : G.name), i = u((N = e.currentFile) == null ? void 0 : N.url);
    w(() => e.currentFile, () => {
      var r, a;
      n.value = (r = e.currentFile) == null ? void 0 : r.name, i.value = (a = e.currentFile) == null ? void 0 : a.url;
    }, { deep: !0 });
    const o = (r) => {
      var d;
      const a = r.target.files || r.dataTransfer && ((d = r.dataTransfer) == null ? void 0 : d.files), t = a[0];
      if (!t) return;
      const y = t.type;
      n.value = t.name, e.isImageUpload && V(a), ["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"].indexOf(y) !== -1 ? k(t) : l("upload:file", t), Z(), I.value = null;
    }, k = (r) => {
      var a = typeof FileReader < "u" && (FileReader.prototype || {}).readAsBinaryString;
      if (typeof Worker < "u") {
        var y = (d) => {
          var F;
          let s = new URL("data:text/javascript;base64,aW1wb3J0U2NyaXB0cygiaHR0cHM6Ly9jZG4uc2hlZXRqcy5jb20veGxzeC0wLjIwLjEvcGFja2FnZS9kaXN0L3hsc3guZnVsbC5taW4uanMiKQpwb3N0TWVzc2FnZSh7IHQ6ICdyZWFkeScgfSkKCm9ubWVzc2FnZSA9IGZ1bmN0aW9uIChldnQpIHsKICB2YXIgd29ya2Jvb2sKICB2YXIgcmVzdWx0ID0ge30KICB0cnkgewogICAgLy8gU2V0IGNlbGxEYXRlcyB0byBmYWxzZSB0byBzdG9yZSBkYXRlcyBhcyBudW1iZXJzCiAgICB3b3JrYm9vayA9IFhMU1gucmVhZChldnQuZGF0YS5kLCB7IHR5cGU6IGV2dC5kYXRhLmIsIGNlbGxEYXRlczogdHJ1ZSB9KQogICAgd29ya2Jvb2suU2hlZXROYW1lcy5mb3JFYWNoKGZ1bmN0aW9uIChzaGVldE5hbWUpIHsKICAgICAgdmFyIHdzID0gd29ya2Jvb2suU2hlZXRzW3NoZWV0TmFtZV07CgogICAgICAvLyBNb2RpZnkgY2VsbHMgaW4gY29sdW1ucyBBIGFuZCBECiAgICAgIGZvciAodmFyIGNlbGxBZGRyZXNzIGluIHdzKSB7CiAgICAgICAgaWYgKGNlbGxBZGRyZXNzWzBdID09PSAnIScpIGNvbnRpbnVlOyAvLyBTa2lwIHNwZWNpYWwgcHJvcGVydGllcwoKICAgICAgICAvLyBFeHRyYWN0IHRoZSBjb2x1bW4gbGV0dGVyKHMpIGFuZCByb3cgbnVtYmVyIGZyb20gdGhlIGNlbGwgYWRkcmVzcwogICAgICAgIHZhciBjb2wgPSBjZWxsQWRkcmVzcy5yZXBsYWNlKC9bMC05XS9nLCAnJyk7CiAgICAgICAgdmFyIHJvdyA9IHBhcnNlSW50KGNlbGxBZGRyZXNzLnJlcGxhY2UoL1tBLVpdL2csICcnKSwgMTApOwogICAgICAgIHZhciBjZWxsID0gd3NbY2VsbEFkZHJlc3NdOwoKICAgICAgICBpZiAoY29sID09PSAnQicgJiYgcm93ICE9PSAxKSB7IC8vIFByb2Nlc3MgY29sdW1uIEEsIHNraXAgaGVhZGVyIChyb3cgMSkKICAgICAgICAgIGlmIChjZWxsLncpIHsKICAgICAgICAgICAgY2VsbC50ID0gJ3MnOyAvLyBTZXQgY2VsbCB0eXBlIHRvIHN0cmluZwogICAgICAgICAgICBjZWxsLnYgPSBjZWxsLnc7IC8vIFNldCBjZWxsIHZhbHVlIHRvIHRoZSBmb3JtYXR0ZWQgdGV4dAogICAgICAgICAgfQogICAgICAgIH0KICAgICAgfQoKICAgICAgLy8gTm93IHByb2NlZWQgd2l0aCBzaGVldF90b19qc29uCiAgICAgIGxldCByb2EgPSBYTFNYLnV0aWxzLnNoZWV0X3RvX2pzb24od3MsIHsKICAgICAgICByYXc6IHRydWUsIC8vIEFwcGx5IGZvcm1hdHRpbmcKICAgICAgICAvLyBkYXRlTkY6ICdkZC9tbS95eXl5IGhoOm1tJyAvLyBBZGp1c3RlZCBmb3JtYXQKICAgICAgfSkKICAgICAgaWYgKHJvYS5sZW5ndGgpIHJlc3VsdFtzaGVldE5hbWVdID0gcm9hCiAgICB9KQogICAgcG9zdE1lc3NhZ2UoeyB0OiAneGxzeCcsIGQ6IEpTT04uc3RyaW5naWZ5KHJlc3VsdCkgfSkKICB9IGNhdGNoIChlcnIpIHsKICAgIHBvc3RNZXNzYWdlKHsgdDogJ2Vycm9yJywgZDogSlNPTi5zdHJpbmdpZnkoZXJyLnN0YWNrIHx8IGVycikgfSkKICB9Cn0=", import.meta.url), A = "";
          s.pathname.includes("dist") ? A = (F = s.pathname.split("/dist/").pop()) == null ? void 0 : F.replace("application", "text") : A = s.href.replace("application", "text");
          var W = new Worker(A || "");
          W.onmessage = (h) => {
            switch (h.data.t) {
              case "ready":
                console.info("worker-ready");
                break;
              case "error":
                console.error(JSON.parse(h.data.d));
                break;
              case "xlsx":
                l("upload:file", JSON.parse(h.data.d));
                break;
            }
          }, W.postMessage({ d, b: a ? "binary" : "array" });
        }, c = new FileReader();
        c.onload = (d) => {
          var s = d.target.result;
          a || (s = new Uint8Array(s)), y(s);
        }, a ? c.readAsBinaryString(r) : c.readAsArrayBuffer(r);
      }
    }, V = (r) => {
      var a = new FileReader();
      a.readAsDataURL(r[0]), a.onload = () => {
        a.result.indexOf("data:image") !== -1 && (i.value = a.result);
      }, a.onerror = function(t) {
        console.log("Error: ", t);
      };
    }, x = () => {
      g.value = !0;
    }, Z = () => {
      g.value = !1;
    };
    return {
      // t,
      fileInput: I,
      fileName: n,
      highlight: g,
      getHighlightClass: b,
      highlightDragArea: x,
      unhighlightDragArea: Z,
      getIconColor: B,
      handleFile: o,
      uploadedFile: i,
      handleDelete: () => {
        var r, a;
        l("upload:delete"), n.value = (r = e.currentFile) == null ? void 0 : r.name, i.value = (a = e.currentFile) == null ? void 0 : a.url, I.value.value = null;
      }
    };
  }
}), E = ["src"], U = { key: 1 }, M = { class: "mt-1 opacity-75" }, j = {
  key: 2,
  class: "p-2 rounded-xl bg-primary-500 text-on-primary flex justify-between"
}, T = ["accept"];
function Q(e, l, g, I, b, B) {
  var i;
  const n = K("vs-icon");
  return p(), C("label", {
    class: X(
      `max-w-xl flex flex-col p-4 text-lg mx-5 sm:mx-auto text-center rounded-xl border-2 border-dashed hover:border-solid text-primary cursor-pointer ${e.getHighlightClass} hover:shadow-md transition-all transform hover:-translate-y-1`
    ),
    onDragover: l[1] || (l[1] = v((...o) => e.highlightDragArea && e.highlightDragArea(...o), ["prevent"])),
    onDragleave: l[2] || (l[2] = (...o) => e.unhighlightDragArea && e.unhighlightDragArea(...o)),
    onDrop: l[3] || (l[3] = v((...o) => e.handleFile && e.handleFile(...o), ["prevent"]))
  }, [
    e.uploadedFile ? (p(), C("img", {
      key: 0,
      class: "max-h-[240px] mx-auto rounded-xl m-4",
      src: e.uploadedFile
    }, null, 8, E)) : f("", !0),
    e.fileName ? f("", !0) : (p(), C("div", U, [
      S(n, {
        class: "mx-auto opacity-75",
        name: e.isImageUpload ? "bi:image-alt" : "entypo:upload-to-cloud",
        color: e.getIconColor,
        size: 48
      }, null, 8, ["name", "color"]),
      m("div", M, " Arrastra y suelta tu " + Y(e.isImageUpload ? "imagen" : "archivo") + " o ", 1),
      l[4] || (l[4] = m("div", { class: "w-40 mx-auto mt-1 py-1 px-2 bg-primary rounded-xl text-on-primary opacity-75" }, "Busca archivo", -1))
    ])),
    e.fileName && e.fileName !== ((i = e.currentFile) == null ? void 0 : i.name) ? (p(), C("div", j, [
      m("div", null, Y(e.fileName), 1),
      S(n, {
        class: "hover:scale-105 hover:opacity-100 opacity-75 cursor-pointer",
        color: "on-primary",
        name: "ic:round-close",
        onClick: v(e.handleDelete, ["prevent"])
      }, null, 8, ["onClick"])
    ])) : f("", !0),
    m("input", {
      ref: "fileInput",
      type: "file",
      accept: e.accept,
      class: "absolute left-0 w-5/12 invisible pointer-events-none",
      onInput: l[0] || (l[0] = (...o) => e.handleFile && e.handleFile(...o))
    }, null, 40, T)
  ], 34);
}
const ee = /* @__PURE__ */ J(D, [["render", Q]]);
export {
  ee as v
};
//# sourceMappingURL=vsUpload-CDWjMLUp.mjs.map
